/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemNumberValidatorDigitsRange } from './formPagePropertyItemNumberValidatorDigitsRange';
import { FormPagePropertyItemNumberErrorMessage } from './formPagePropertyItemNumberErrorMessage';
import { FormPagePropertyItemNumberInputFormat } from './formPagePropertyItemNumberInputFormat';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * 数値型の入力項目を表す。 type: number としたいが、number だと指数表現など、NEWT フォームで許可しないものも許可できてしまうため、 string で pattern チェック を行ない、桁数チェックはカスタムバリデータキーワードで対応する。 classic では 文字の自動変換はオプショナルであったが、NEWT フォームでは 強制で全角 -> 半角のルールを stringConvertRule にセットする。 
 */
export interface FormPagePropertyItemNumber { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'number';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemNumber.TypeEnum;
    /**
    * 入力可能な数値フォーマットを正規表現として表現。 ^[-+]?(0|[1-9]{1}[0-9]{0,})(?:\\\\.[0-9]{0,})?$ ・最初に1つプラス or マイナスがつく可能性がある ・最初は0 or 数字(1-9)から始まる ・間に小数点(.)が一つだけ入る ・最後は小数点 or 数字で終わる 
    */
    pattern: string;
    /**
    * 態度尺度として正しい値のリスト
    */
    enum?: Array<string>;
    digitsRange: FormPagePropertyItemNumberValidatorDigitsRange;
    inputFormat: FormPagePropertyItemNumberInputFormat;
    errorMessage?: FormPagePropertyItemNumberErrorMessage;
}

export namespace FormPagePropertyItemNumber {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}


